<template>
  <div class="content-voucher mt-2">
    <div v-if="voucherCustomerLookupList.length > 0">
      <div class="table-responsive">
        <table class="table table-sm">
          <thead class="thead">
            <tr>
              <th scope="col">{{ "#" }}</th>
              <th scope="col">{{ $t("lookUpVoucher.supplier") }}</th>
              <th scope="col">{{ $t("voucherManagement.table.voucherName") }}</th>
              <th scope="col">{{ $t("lookUpVoucher.voucherSerial") }}</th>
              <th scope="col">{{ $t("lookUpVoucher.activationCode") }}</th>
              <th scope="col">{{ $t("voucherManagement.table.denominations") }}</th>
              <th scope="col">{{ $t("lookUpVoucher.startDate") }}</th>
              <th scope="col">{{ $t("lookUpVoucher.endDate") }}</th>
              <th scope="col">{{ $t("lookUpVoucher.detailInfo") }}</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(eVoucher, index) in voucherCustomerLookupList"
              :key="eVoucher + index"
            >
              <td class="text-center">{{ eVoucher.stt }}</td>
              <td>{{ eVoucher.supplierName }}</td>
              <td>{{ eVoucher.voucherName }}</td>
              <td>{{ eVoucher.voucherSerial }}</td>
              <td>{{ eVoucher.activeCode }}</td>
              <td class="text-right">{{ eVoucher.price }}</td>
              <td class="text-center">{{ eVoucher.startDate }}</td>
              <td class="text-center">{{ eVoucher.endDate }}</td>
              <td>
                  <a :href="removeDoubleSlashesFromUrl(currentDomain + '/viewsdetail/' + eVoucher.id + '/' + eVoucher.voucherSerial + '/?phone='+(phoneNumber?phoneNumber:'-'))" target="_blank">{{ $t('common.detail') }}</a>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <paginate
        v-show="voucherCustomerLookupList.length > 0"
        :rows="paginator.totalPage"
        :per-page="paginator.perPage"
        :current-page="paginator.currentPage"
        :total-item="paginator.count"
        @onPageChange="pageChange"
      />
      <loadingBar v-if="isLoading" :useSlot="true" :isLoading="isLoading" />
    </div>
    <div v-else-if="phoneNumber">
      <div class="error-content">
        <span>{{ $t('lookUpVoucher.invalidVoucherLinkMessage') }}</span>
      </div>
    </div>
    <inputConfirmModal
      ref="inputConfirmModal"
      :titleText="$t('lookUpVoucher.confirmAccessInfo')"
      :inputCaptionText="$t('lookUpVoucher.inputCaptionPhone')"
      :inputHintText="$t('lookUpVoucher.inputHintPhone')"
      :btnConfirmText="$t('common.confirm')"
      @onConfirm="onConfirmPhone"
    />
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import stringUtils from 'Utils/stringUtils'
import functionUtils from 'Utils/functionUtils'
import InputConfirmModal from 'Components/InputConfirmModal'

export default {
  components: {
    InputConfirmModal
  },
  data: () => ({
    voucherCustomerLookupList: [],
    phoneNumber: null,
    isLoading: false,
    paginator: {
      count: 0,
      currentPage: 1,
      totalPage: 1,
      rowPerPage: 1,
    },
    currentDomain: stringUtils.DOMAIN_BASE_PATH
  }),
  mounted() {
    this.getVouchersOfViewer(1);
  },
  methods: {
    onConfirmPhone: function (inputPhone) {
      this.phoneNumber = inputPhone
      this.getVouchersOfViewer(1);
    },
    getVouchersOfViewer: function (page) {
      this.isLoading = true;
      let code = this.$route.params.code;
      let filter = {
        params: {
          code: code,
          phone: this.phoneNumber,
          page: page,
        },
      };
      this.GET_VOUCHERS_OF_VIEWER(filter).then(
        function (res) {
          let data = res.data
          let results = data.results
          for (let i = 0, size = results.length; i < size; i++) {
            let obj = {
              stt: i + 1 + (data.page - 1) * data.page_size,
              id: results[i].id,
              supplierName: results[i].supplier_name,
              voucherName: results[i].voucher_name,
              activeCode: results[i].activation_code,
              voucherSerial: results[i].voucher_serial,
              startDate: results[i].start_date,
              endDate: results[i].end_date,
              price: results[i].voucher_value
            }
            this.voucherCustomerLookupList.push(obj)
          }
          this.$refs.inputConfirmModal.onHideModal()
          this.isLoading = false;
        }.bind(this)
      ).catch(
        function (error) {
          if (error.response.status !== 404) {
            this.phoneNumber = '-'
            this.showToast(this.$t(functionUtils.errorResponse(error.response)))
            this.$refs.inputConfirmModal.onHideModal()
          } else {
            if (this.phoneNumber !== null) {
              this.showToast(this.$t(functionUtils.errorResponse(error.response)))
            }
            this.phoneNumber = null
            this.$refs.inputConfirmModal.onShowModal()
          }
          this.isLoading = false;
        }.bind(this)
      )
    },
    showToast: function (message) {
      this.$toast.clear();
      this.$toast.error(
        message,
        {
          position: "bottom-left",
          timeout: 1500,
          closeOnClick: true,
          pauseOnFocusLoss: true,
          pauseOnHover: true,
          draggable: true,
          draggablePercent: 0.6,
          showCloseButtonOnHover: false,
          hideProgressBar: false,
          closeButton: "button",
          icon: true,
          rtl: false,
        }
      );
    },
    removeDoubleSlashesFromUrl: function (url) {
      return functionUtils.removeDoubleSlashesFromUrl(url)
    },
    pageChange(page) {
      this.paginator.currentPage = page;
      this.getVouchersOfViewer(page);
    },
    ...mapActions(['GET_VOUCHERS_OF_VIEWER'])
  },
};
</script>

<style lang="scss" scoped>
.table > tr, th, td {
    white-space: nowrap;
    font-family: monospace;
}
.error-content {
  width: 100vw;
  height: 90vh;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  padding: 10px 30px;
}
</style>
